import React from "react"
import * as footerStyles from "./Footer.module.scss"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import SmartLink from "../SmartLink/SmartLink"
import { useLocation } from "@reach/router"

const Footer = () => {
  const currentLoaction = useLocation()

  const data = useStaticQuery(graphql`
    query {
      allContentfulFooter {
        nodes {
          gamesList {
            gameCards {
              title
              linkUrl
              gameIcon350w {
                description
                gatsbyImageData(placeholder: NONE, width: 350, height: 350)
              }
            }
          }

          pageLinksList {
            title
            slug
          }
        }
      }
    }
  `)
  const { gamesList } = data.allContentfulFooter.nodes[0]

  const gameIcons = gamesList.gameCards.map(gameCard => {
    const { linkUrl, gameIcon350w, title } = gameCard
    return {
      title,
      linkUrl,
      description: gameIcon350w.description,
      gameIcon350w,
    }
  })

  return (
    <footer className={footerStyles.footer}>
      {currentLoaction.pathname === "/games/monopoly-slots/" && (
        <div className={footerStyles.monopolyText}>
          The MONOPOLY name and logo, the distinctive design of the game board,
          the four corner squares, the MR. MONOPOLY name and character, as well
          as each of the distinctive elements of the board, cards, and the
          playing pieces are trademarks of Hasbro for its property trading game
          and game equipment and are used with permission. © 1935, 20XX Hasbro.
          All Rights Reserved. Licensed by Hasbro.
        </div>
      )}
      <div className={footerStyles.icons}>
        {gameIcons.map((item, ind) => {
          const image = getImage(item.gameIcon350w)
          return (
            <div
              key={`footer-game-icon-${ind}`}
              className={footerStyles.gameIcon}
            >
              <SmartLink href={item.linkUrl} aria-label={item.title}>
                <GatsbyImage image={image} alt={item.description} />
              </SmartLink>
            </div>
          )
        })}
      </div>

      <div className={footerStyles.importantInfo}>
        <div className={footerStyles.copyrights}>
          © Copyright {new Date().getFullYear()}. SciPlay Corporation. All
          Rights Reserved.
        </div>
        <div className={footerStyles.usefulLinks}>
          <div className={footerStyles.link}>
            <Link to="/terms-of-service#!/terms">Terms of Service</Link>
          </div>
          <div className={footerStyles.link}>
            <Link to="/terms-of-service#!/privacy">Privacy Policy</Link>
          </div>
          <div className={footerStyles.link}>
            <Link to="/terms-of-service#!/cookies">Cookies</Link>
          </div>
          <div className={footerStyles.link}>
            <Link to="/delete-account">Account Deletion</Link>
          </div>
          {/* {pageLinksList.map((item, ind) => {
            const { title, slug } = item
            return (
              <div key={`footer-link-${ind}`} className={footerStyles.link}>
                {slug ? <Link to={`/${slug}`}>{title}</Link> : `${item}`}
              </div>
            )
          })} */}
        </div>
      </div>
    </footer>
  )
}

export default Footer
